module.exports = __webpack_public_path__ + "sfr.9dd73f9.png";